import React, { useState, useEffect } from "react";
import MerchantsTable from "./components/MerchantsTable";
import Edit from "./modals/Edit";
import View from "./modals/View";
import Delete from "./modals/Remove";
import Create from "./modals/Create";
import Filter from "./modals/Filter";
import Divider from "@material-ui/core/Divider";
import axios from "axios";
import { v4 as uuid } from "uuid";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { updateObject } from "../../../helpers/updateObject";


export default function Merchants() {
    const [showEdit, setShowEdit] = useState(false);
    const [showView, setShowView] = React.useState(false);
    const [showRemove, setShowRemove] = useState(false);
    const [showCreate, setShowCreate] = useState(false);


    const toggleDrawer = (open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }

        setShowView(open);
    };

    const [error, setError] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [sortField, setSortField] = useState("id");
    const [orderBy, setOrderBy] = useState(false);
    const [rows, setRows] = useState([]);
    const [merchant, setMerchant] = useState({});
    const [skip, setSkip] = useState(0);
    const [take, setTake] = useState(10);
    const [count, setCount] = useState(0);
    const [merchantId, setMerchantId] = useState(null);
    const [deleteMerchantsIds, setDeleteMerchantsIds] = useState([]);
    const [showFilter, setShowFilter] = React.useState(false);

    const [partners, setPartners] = useState([]);

    const [filter, setFilter] = useState(false);
    const [filterInputs, setFilterInputs] = useState({
        name: "",
        email: "",
        phone: "",
        partnerName: "",

    });

    function handleChange() {
        setShowFilter((key) => !key);
    }

    const [cities, setCities] = useState([]);


    const onMerchants = (skip, take, sortField, orderBy) => {
        const {
            name, email, phone, partnerName
        } = filterInputs;

        setIsLoaded(true);
        axios
            .get(
                `${process.env.REACT_APP_API_URL}partner/merchant?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}${partnerName ? `&partnerName=${partnerName}` : ""}${phone ? `&phone=${phone}` : ""}${email ? `&email=${email}` : ""}${name ? `&name=${name}` : ""}`,
                {
                    headers: {
                        "Accept-Language": 1,
                    },
                }
            )
            .then(
                ({ data: { data, totalCount } }) => {
                    setIsLoaded(false);
                    setRows(data);
                    setCount(totalCount);
                    setError(false);
                }
            ).catch((error) => {
                setIsLoaded(false);
                setError(true);
                setRows([]);
                setCount(0);
            });
    };


    const onMerchantChoose = (id) => {
        axios
            .get(`${process.env.REACT_APP_API_URL}partner/merchant/${id}`)
            .then(({ data }) => {
                setMerchant(data);
            });
    };


    const onDeleteMerchants = () => {
        axios
            .delete(`${process.env.REACT_APP_API_URL}partner/merchant`, {
                headers: {
                    "x-requestid": uuid(),
                },
                data: {
                    id: deleteMerchantsIds,
                },
            })
            .then((res) => {
                setDeleteMerchantsIds([]);
                onMerchants(skip, take, sortField, orderBy);
            });
    };


    // const loadOptionsPartner = async (search, loadedOptions, { page }) => {
    //     const response = await axios.get(
    //         `${process.env.REACT_APP_API_URL}partner?&Skip=${page * 30}&Take=30`
    //     );

    //     let responseJSON = await response.data.data;
    //     responseJSON = responseJSON.map((item) => ({
    //         value: item.id,
    //         label: item.name
    //     }));

    //     return {
    //         options: responseJSON,
    //         hasMore: responseJSON.length ? true : false,
    //         additional: {
    //             page: page + 1
    //         }
    //     };

    // };

    const onPartners = () => {
        axios
            .get(`${process.env.REACT_APP_API_URL}partner`, {
                headers: {
                    "Accept-Language": 1,
                },
            })
            .then(({ data: { data } }) => {
                setPartners(data);
            });
    };

    useEffect(() => {
        onPartners();
    }, []);
    // useEffect(() => {
    //     onMerchants(skip, take, sortField, orderBy);
    // }, [skip, take, sortField, orderBy]);
    useEffect(() => {
        const timer = setTimeout(() => {
            onMerchants(skip, take, sortField, orderBy, filterInputs);
        }, 500);
        return () => clearTimeout(timer);
    }, [skip, take, sortField, orderBy, filterInputs]);

    useEffect(() => {
        if (!showView || !showEdit) setMerchant({});
    }, [showView, showEdit]);


    const onMerchantsExport = () => {
        axios
            .get(`${process.env.REACT_APP_API_URL}partner/merchant/export`, {
                responseType: "blob",
            })
            .then((res) => {
                var url = window.URL.createObjectURL(new Blob([res.data]));
                var a = document.createElement("a");
                a.href = url;
                a.download = "Merchant.xlsx";
                document.body.appendChild(a);
                a.click();
                a.remove();
            });
    };

    const filterInputsUpdate = (e) => {
        const updateFiltersInput = updateObject(filterInputs, {
            [e.target.name]: e.target.value,
        });

        setFilterInputs(updateFiltersInput);
        setSkip(0);
        setFilter(true);
    };

    const filterInputsUpdateSelect = (key, value) => {
        const updateFiltersInput = updateObject(filterInputs, {
            [key]: value,
        });

        setFilterInputs(updateFiltersInput);
        setSkip(0);
        setFilter(true);
    };


    const onCities = () => {
        axios
            .get(`${process.env.REACT_APP_API_URL}partner/cities/${merchant?.partnerId}`, {
                headers: {
                    "Accept-Language": 1,
                },
            })
            .then(({ data: { data } }) => {
                setCities(data);
                // console.log(data)
            });
    };


    useEffect(() => {
        onCities(merchant?.partnerId)
    }, [merchant?.partnerId]);

    return (
        <div className="row bg-white rounded">
            <div className="col-12 d-flex align-items-center py-4">
                <h1 className="display-4 mb-0">Merchants</h1>
                <FormControlLabel
                    control={
                        <Switch
                            checked={showFilter}
                            onChange={handleChange}
                            color="secondary"
                        />
                    }
                    label={showFilter ? "Hide filter" : "Show filter"}
                    className="ml-auto mb-0"
                />
            </div>
            <Divider className="w-100" />
            <MerchantsTable
                setSortField={setSortField}
                setOrderByTable={setOrderBy}
                sortField={sortField}
                orderBy={orderBy}
                setOpenEdit={setShowEdit}
                setOpenView={toggleDrawer(true)}
                setOpenRemove={setShowRemove}
                setOpenCreate={setShowCreate}
                isLoaded={isLoaded}
                error={error}
                rows={rows}
                onMerchantChoose={onMerchantChoose}
                updateSkip={setSkip}
                updateTake={setTake}
                count={count}
                setMerchantId={setMerchantId}
                setDeleteMerchantsID={setDeleteMerchantsIds}
                deleteMerchantsIds={deleteMerchantsIds}
                onDeleteMerchants={onDeleteMerchants}
                onMerchantsExport={onMerchantsExport}
            />
            <Edit
                merchant={merchant}
                show={showEdit}
                onHide={setShowEdit}
                skip={skip}
                take={take}
                sortField={sortField}
                orderBy={orderBy}
                onMerchants={onMerchants}
                // assets={assets}
                cities={cities}
                setCities={setCities}
                // loadOptionsPartner={loadOptionsPartner}
                partners={partners}

            />
            <View
                merchant={merchant}
                open={showView}
                onClose={toggleDrawer(false)}
            />
            <Delete
                id={merchantId}
                show={showRemove}
                onHide={setShowRemove}
                skip={skip}
                take={take}
                sortField={sortField}
                orderBy={orderBy}
                onMerchants={onMerchants}
            />
            <Create
                show={showCreate}
                onHide={setShowCreate}
                onMerchants={onMerchants}
                skip={skip}
                take={take}
                sortField={sortField}
                orderBy={orderBy}
                cities={cities}
                setCities={setCities}
                // loadOptionsPartner={loadOptionsPartner}
                partners={partners}

            />

            <Filter
                show={showFilter}
                onHide={handleChange}
                filterInputsUpdate={filterInputsUpdate}
                filterInputs={filterInputs}
                filterInputsUpdateSelect={filterInputsUpdateSelect}
                partners={partners}
            // loadOptionsPartner={loadOptionsPartner}

            />
        </div>
    );
}
